export default __webpack_public_path__ + "static/media/icon-map.4c1d0a5c.svg";